import {
  flagEnabled as baseFlagEnabled,
  devFlagEnabled as baseDevFlagEnabled,
  devFlagValue as baseDevFlagValue,
  SharedFlags,
  SharedDevFlags,
} from "@vault/common/misc/flags";

// required to avoid linting errors when there are no flags
/* eslint-disable-next-line @typescript-eslint/ban-types */
export type Flags = {
  secretsManager?: boolean;
  showPasswordless?: boolean;
  benchmark?: boolean;
  accountFiltering?: boolean;
  /**
   * When explicitly `true`, Remove Basiq consent and related Basiq UI are shown.
   * Missing or `false` hides them (unlike most flags, which default on).
   */
  basiqIntegration?: boolean;
  /** When explicitly `true`, auto credit redemption preference and gloss-credit enrollment are enabled. */
  autoCreditRedemption?: boolean;
  /**
   * Shows the "Sign in with Google" button on the login page. Explicitly `false` in base
   * until gloss-back's `google` grant is deployed to every environment.
   */
  googleSignIn?: boolean;
} & SharedFlags;

export type FlagsTypeKeys = keyof Flags;

// required to avoid linting errors when there are no flags
/* eslint-disable-next-line @typescript-eslint/ban-types */
export type DevFlags = {} & SharedDevFlags;

export function flagEnabled(flag: keyof Flags): boolean {
  return baseFlagEnabled<Flags>(flag);
}

export function devFlagEnabled(flag: keyof DevFlags) {
  return baseDevFlagEnabled<DevFlags>(flag);
}

export function devFlagValue(flag: keyof DevFlags) {
  return baseDevFlagValue(flag);
}

/**
 * Basiq consent UI is opt-in only: returns true only when `FLAGS.basiqIntegration === true`.
 */
export function basiqIntegrationEnabled(): boolean {
  const raw = process.env.FLAGS as string | Flags | undefined;
  if (raw == null) {
    return false;
  }
  let flags: Partial<Flags>;
  if (typeof raw === "string") {
    try {
      flags = JSON.parse(raw) as Partial<Flags>;
    } catch {
      return false;
    }
  } else {
    flags = raw as Partial<Flags>;
  }
  return flags.basiqIntegration === true;
}

export function autoCreditRedemptionEnabled(): boolean {
  const raw = process.env.FLAGS as string | Flags | undefined;
  if (raw == null) {
    return false;
  }
  let flags: Partial<Flags>;
  if (typeof raw === "string") {
    try {
      flags = JSON.parse(raw) as Partial<Flags>;
    } catch {
      return false;
    }
  } else {
    flags = raw as Partial<Flags>;
  }
  return flags.autoCreditRedemption === true;
}
